export default __webpack_public_path__ + "static/media/videos_profono_acesso.71b47260.png";